import { i18n } from '@/lang/setup';
import VueI18n from 'vue-i18n';

export function useI18n(): VueI18n {
  return i18n;
}
